const toggleVisibility = (banner, items) => {
  if (items && items.length) {
    banner.classList.add('c-picklist-banner--active');
  } else {
    banner.classList.remove('c-picklist-banner--active');
  }
};

/**
 * Updates mailto with body for all items
 * @param {HTMLAnchorElement} mailLink
 * @param {PicklistItem[]}items
 */
const updateEmailLink = (mailLink, items) => {
  if (!mailLink) return;
  const body = items.reduce(
    (acc, item) =>
      `${acc}${item.name} ${
        item.articleNumber ? `(${item.articleNumber})` : ''
      }\n${item.url}\n\n`,
    '',
  );
  mailLink.href = `mailto:?body=${encodeURIComponent(body)}`;
};

/**
 *
 * @param {HtmlElement} itemsElement
 * @param items
 */
const updateNumItems = (itemsElement, items) => {
  if (!itemsElement) return;
  const { template } = itemsElement.dataset;
  itemsElement.innerHTML = template.replace('{0}', items.length);
};

/**
 * Creates and handles the picklist banner via the returned update function
 * @param {HtmlElement} bannerElement
 * @param {PicklistItem[]} initialItems
 * @returns {{update: Function}}
 * @constructor
 */
const PicklistBanner = (bannerElement, initialItems) => {
  const banner = bannerElement;
  const mailLink = banner.querySelector('.c-picklist-banner-maillink');
  const itemsText = banner.querySelector('.c-picklist-items-text');
  /**
   * Update banner
   * @param {PicklistItem[]}items
   * @returns {void}
   */
  const update = items => {
    toggleVisibility(banner, items);
    updateEmailLink(mailLink, items);
    updateNumItems(itemsText, items);
  };
  update(initialItems);
  return {
    update,
  };
};

export default PicklistBanner;
